import React from "react"
import badge from "badges/second-column-badge-blocked.svg"
import { BadgeImage } from "backpack/badges/styled"

const SecondColumnBadgeBlocked = props => <BadgeImage src={badge} {...props} />

export default SecondColumnBadgeBlocked
